export default "__VITE_ASSET__8c31cafc__"